import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeftIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function TerminosPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="pt-20" data-id="element-575">
      <section className="relative py-16 md:py-20 bg-brand-navy overflow-hidden" data-id="element-576">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,_var(--tw-gradient-stops))] from-brand-royal/30 via-brand-navy to-brand-navy" data-id="element-577"></div>
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-578">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7
        }} data-id="element-579">
            <Link to="/" className="inline-flex items-center gap-2 text-white/60 hover:text-brand-gold transition-colors text-sm mb-8 group" data-id="element-580">
              <ArrowLeftIcon className="w-4 h-4 group-hover:-translate-x-1 transition-transform" data-id="element-581" />
              Volver al inicio
            </Link>
            <h1 className="text-4xl md:text-5xl font-heading font-bold text-white leading-tight" data-id="element-582">
              Términos y Condiciones de{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-gold to-yellow-200" data-id="element-583">
                Uso
              </span>
            </h1>
          </motion.div>
        </div>
      </section>

      <section className="py-16 md:py-20" data-id="element-584">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-gray-700 leading-relaxed space-y-8" data-id="element-585">
          <div data-id="element-586">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-587">
              1. ACEPTACIÓN DE LOS TÉRMINOS
            </h2>
            <p data-id="element-588">
              Al acceder, navegar, registrarse o utilizar el sitio web,
              aplicación móvil o cualquier plataforma digital oficial de
              Fundación REDORG (en adelante nombrados como la "Plataforma" y
              "REDORG" respectivamente), el usuario declara haber leído,
              entendido y aceptado íntegramente los presentes Términos y
              Condiciones, así como la Política de Privacidad vigente.
            </p>
            <p className="mt-2" data-id="element-589">
              Si el usuario no está de acuerdo con estos Términos, deberá
              abstenerse de utilizar la Plataforma.
            </p>
          </div>

          <div data-id="element-590">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-591">
              2. IDENTIFICACIÓN DEL TITULAR
            </h2>
            <p data-id="element-592">
              La Plataforma es operada por REDORG, entidad sin fines de lucro
              constituida conforme a las leyes de la República del Ecuador.
            </p>
          </div>

          <div data-id="element-593">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-594">
              3. USUARIOS
            </h2>
            <p className="mb-3" data-id="element-595">Pueden utilizar la Plataforma:</p>
            <ul className="list-disc ml-6 space-y-1" data-id="element-596">
              <li data-id="element-597">Personas naturales mayores de 18 años</li>
              <li data-id="element-598">
                Menores de edad bajo la responsabilidad expresa de su padre,
                madre o representante legal, especialmente en el caso de
                escuelas deportivas
              </li>
            </ul>
            <p className="mt-2" data-id="element-599">
              El usuario es responsable de la veracidad de la información
              proporcionada durante su registro.
            </p>
          </div>

          <div data-id="element-600">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-601">
              4. SERVICIOS OFRECIDOS
            </h2>
            <p className="mb-3" data-id="element-602">La Plataforma permite, entre otros:</p>
            <ul className="list-disc ml-6 space-y-1" data-id="element-603">
              <li data-id="element-604">
                Administración de organizaciones, aliados, socios y adherentes.
              </li>
              <li data-id="element-605">Administración y venta de productos y servicios.</li>
              <li data-id="element-606">
                Inscripción para eventos, capacitaciones, actividades u otros.
              </li>
              <li data-id="element-607">
                Pago de mensualidades, matrículas y otros valores relacionados
                con productos y servicios.
              </li>
              <li data-id="element-608">Acceso a contenido informativo, promocional y multimedia.</li>
              <li data-id="element-609">Otros productos y servicios.</li>
            </ul>
            <p className="mt-2" data-id="element-610">
              REDORG se reserva el derecho de modificar, suspender o eliminar
              servicios sin previo aviso.
            </p>
          </div>

          <div data-id="element-611">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-612">
              5. REGISTRO Y CUENTAS
            </h2>
            <p className="mb-3" data-id="element-613">
              Para acceder a ciertos servicios, el usuario deberá crear una
              cuenta proporcionando información veraz y actualizada.
            </p>
            <p className="mb-3" data-id="element-614">El usuario es responsable de:</p>
            <ul className="list-disc ml-6 space-y-1" data-id="element-615">
              <li data-id="element-616">Mantener la confidencialidad de su usuario y contraseña.</li>
              <li data-id="element-617">Todas las actividades realizadas desde su cuenta.</li>
            </ul>
            <p className="mt-2" data-id="element-618">
              REDORG no será responsable por el uso no autorizado de cuentas por
              negligencia del usuario.
            </p>
          </div>

          <div data-id="element-619">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-620">
              6. CONDICIONES DE VENTA – PRODUCTOS Y SERVICIOS
            </h2>
            <ul className="list-disc ml-6 space-y-1" data-id="element-621">
              <li data-id="element-622">
                Los productos y servicios están sujetos a disponibilidad de
                stock.
              </li>
              <li data-id="element-623">
                Los precios incluyen los impuestos aplicables conforme a la ley
                ecuatoriana.
              </li>
              <li data-id="element-624">
                Las imágenes son referenciales; pueden existir variaciones
                mínimas.
              </li>
              <li data-id="element-625">
                Cambios o devoluciones solo se aceptarán por defectos de
                fabricación o falta de prestación de servicio, conforme a la
                política vigente.
              </li>
            </ul>
            <p className="mt-2" data-id="element-626">
              REDORG no se responsabiliza por retrasos atribuibles a terceros
              (courier, fuerza mayor, etc.).
            </p>
          </div>

          <div data-id="element-627">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-628">
              7. PAGOS Y TRANSACCIONES
            </h2>
            <ul className="list-disc ml-6 space-y-1" data-id="element-629">
              <li data-id="element-630">
                Todos los pagos se procesan a través de plataformas seguras de
                terceros.
              </li>
              <li data-id="element-631">REDORG no almacena información bancaria sensible.</li>
              <li data-id="element-632">
                El usuario autoriza el débito de los valores correspondientes a
                los productos y servicios adquiridos.
              </li>
            </ul>
            <p className="mt-2" data-id="element-633">
              Cualquier reclamo deberá realizarse dentro de los plazos
              establecidos por la ley.
            </p>
          </div>

          <div data-id="element-634">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-635">
              8. PROPIEDAD INTELECTUAL
            </h2>
            <p data-id="element-636">
              Todo el contenido de la Plataforma (logos, escudos, textos,
              imágenes, videos, diseños, marcas y software) es propiedad
              exclusiva de REDORG o de terceros autorizados.
            </p>
            <p className="mt-2" data-id="element-637">
              Queda prohibida su reproducción, distribución o uso comercial sin
              autorización expresa y por escrito.
            </p>
          </div>

          <div data-id="element-638">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-639">
              9. USO PROHIBIDO
            </h2>
            <p className="mb-3" data-id="element-640">El usuario se compromete a no:</p>
            <ul className="list-disc ml-6 space-y-1" data-id="element-641">
              <li data-id="element-642">Utilizar la Plataforma con fines ilícitos.</li>
              <li data-id="element-643">Realizar fraudes o suplantación de identidad.</li>
              <li data-id="element-644">Introducir virus, malware o códigos dañinos.</li>
              <li data-id="element-645">Afectar el funcionamiento de la Plataforma.</li>
            </ul>
            <p className="mt-2" data-id="element-646">
              El incumplimiento podrá resultar en la suspensión o cancelación
              inmediata de la cuenta.
            </p>
          </div>

          <div data-id="element-647">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-648">
              10. RESPONSABILIDAD Y LIMITACIONES
            </h2>
            <p className="mb-3" data-id="element-649">REDORG no garantiza:</p>
            <ul className="list-disc ml-6 space-y-1" data-id="element-650">
              <li data-id="element-651">Disponibilidad ininterrumpida de la Plataforma.</li>
              <li data-id="element-652">Ausencia total de errores técnicos.</li>
            </ul>
            <p className="mt-2" data-id="element-653">
              El uso de la Plataforma se realiza bajo responsabilidad exclusiva
              del usuario.
            </p>
          </div>

          <div data-id="element-654">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-655">
              11. PROTECCIÓN DE DATOS PERSONALES
            </h2>
            <p data-id="element-656">
              El tratamiento de los datos personales se rige por la Política de
              Privacidad de REDORG y la normativa vigente en Ecuador.
            </p>
          </div>

          <div data-id="element-657">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-658">
              12. VIGENCIA Y MODIFICACIONES
            </h2>
            <p data-id="element-659">REDORG podrá modificar estos Términos en cualquier momento.</p>
            <p className="mt-2" data-id="element-660">
              La vigencia de estos Términos y Condiciones de Uso es desde el 20
              de marzo de 2026 y permanecerá vigente hasta que exista una nueva
              versión que la reemplace.
            </p>
          </div>

          <div data-id="element-661">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-662">
              13. LEGISLACIÓN Y JURISDICCIÓN
            </h2>
            <p data-id="element-663">
              Estos Términos se rigen por las leyes de la República del Ecuador.
            </p>
            <p className="mt-2" data-id="element-664">
              Cualquier controversia será sometida a los jueces competentes de
              la ciudad de Guayaquil.
            </p>
          </div>

          <div data-id="element-665">
            <h2 className="font-heading font-bold text-brand-navy text-xl mb-3" data-id="element-666">
              14. CONTACTO
            </h2>
            <p data-id="element-667">
              Para consultas o reclamos, el usuario puede comunicarse a través
              de los canales oficiales de REDORG disponibles en la Plataforma.
            </p>
          </div>
        </motion.div>
      </section>
    </div>;
}